import KoobInputText from '@koob/ui/src/components/KoobInputText';
import { useTripFilters } from '../../hooks/useTripStoreSelectors';
import { useUpdateTripFilter } from '../../hooks/useUpdateTripFilter';
import type { FilterItem } from '../../logic/tripFilterOptions';
import TripFilterMultiSelect from './TripFilterMultiSelect';

interface Props {
  t: (key: string) => string;
  themes: { items: FilterItem[]; isLoading: boolean };
  segments: { items: FilterItem[]; isLoading: boolean };
}

const pointStyle = { width: 170, borderRadius: '9999px' };

// Experience search: themes, segments, start and end point.
export default function TripFilterExperience({ t, themes, segments }: Props) {
  const tripFilters = useTripFilters();
  const updateFilter = useUpdateTripFilter();

  return (
    <>
      <TripFilterMultiSelect
        property="themes"
        placeholder={t('search.experienceTheme')}
        items={themes.items}
        loading={themes.isLoading}
        limited
      />
      <TripFilterMultiSelect
        property="segments"
        placeholder={t('search.experienceSegment')}
        items={segments.items}
        loading={segments.isLoading}
        limited
      />
      {/* Not grouped in one flex div: as a single 350px block the pair
          wrapped together and orphaned "More filters" on narrow columns. */}
      <KoobInputText
        placeholder={t('search.startLocation')}
        defaultValue={tripFilters?.startingPoint}
        onKeyUp={(event: any) =>
          updateFilter('startingPoint', event.target.value)
        }
        style={pointStyle}
      />
      <KoobInputText
        placeholder={t('search.endLocation')}
        defaultValue={tripFilters?.endingPoint}
        onKeyUp={(event: any) =>
          updateFilter('endingPoint', event.target.value)
        }
        style={pointStyle}
      />
    </>
  );
}
